<template>
  <div class="automation">
    <div style="margin-bottom: 10px">
      <el-button style="float: left" @click="goBack" type="primary"
        ><i class="fas fa-arrow-left"></i> Go Back</el-button
      >
      <!-- <el-button @click="openModal('new')" type="primary" style="float: right"
        >+ Add new Notice Template</el-button
      > -->
    </div>
    <div style="clear: both"></div>
    <hr style="margin-top: 10px" />
    <el-table
      :data="data"
      style="width: 100%"
      :default-sort="{ prop: 'created_at', order: 'ascending' }"
      v-loading="loading"
    >
      <!-- <el-table-column prop="when" label="Actions" sortable>
        <template slot-scope="scope">
          <div :key="action.id" v-for="action in scope.row.actions">
            <small>{{ child }}</small>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="parent" label="Parent" sortable></el-table-column> -->
      <el-table-column
        prop="automation_id"
        label="Automation Id"
        sortable
      ></el-table-column>
      <el-table-column
        prop="automation_type"
        label="Automation type"
        sortable
      ></el-table-column>
      <el-table-column
        prop="content_type"
        label="Content Type"
        sortable
      ></el-table-column>
      <el-table-column prop="user_type" label="Type" sortable></el-table-column>
      <el-table-column
        prop="created_at"
        label="Created"
        sortable
      ></el-table-column>
      <el-table-column
        prop="updated_at"
        label="Updated"
        sortable
      ></el-table-column>
      <el-table-column label="Actions">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="viewDetailedLogs(scope.row.automation_id)"
            >View detailed
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import CreatePost from "@/views/CreatePost.vue";
import ApiService from "@/services/ApiService";
export default {
  name: "AutomationsLogs",
  data() {
    return {
      page: 0,
      filterAutomationId: 0,
      data: [
        // {
        //   id: 1,
        //   name: "Test template",
        //   description: "It should do this and that",
        //   created_at: "May 5th, 22",
        //   edited_at: "May 5th, 22",
        // },
      ],
      loading: false,
    };
  },
  methods: {
    goBack() {
      this.$router.push("/members/automations");
    },
    goto(path) {
      path = "actions/" + path;
      this.$router.push(path);
    },
    openModal(id) {
      this.$modal.show(
        CreatePost,
        {
          id,
          isTemplate: true,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          width: 1000,
          height: "auto",
          adaptive: true,
        }
      );
    },
    loadNextPage() {
      this.page = this.page + 1;
      this.getAutomationsLogs();
    },
    // action(type, id) {
    //   if (type === "edit") {
    //     this.$router.push("/members/edit-email-template/" + id);
    //   }
    // },
    getAutomationsLogs() {
      ApiService.automationsApi
        .getLogs(this.page, this.filterAutomationId)
        .then((resp) => {
          this.data = resp.data;
        });
    },
    viewDetailedLogs(automationId) {
      this.$router.push("/members/automations/detailed_logs/" + automationId);
    },
  },
  mounted() {
    this.getAutomationsLogs();
  },
};
</script>
